import { Colors } from 'works/legacy/lib/style-helper';

export const stateDisplayMap = {
  open: {
    label: 'Open',
    color: Colors.harvestGold,
  },
  expired: {
    label: 'Expired',
    color: Colors.coral,
  },
  cancelled: {
    label: 'Cancelled',
    color: Colors.textDefault,
  },
  claimed: {
    label: 'Pending Approval',
    color: Colors.harvestGold,
  },
  accepted: {
    label: 'Approved',
    color: Colors.textDefault,
  },
  rejected: {
    label: 'Rejected',
    color: Colors.coral,
  },
  retracted: {
    label: 'Retracted',
    color: Colors.coral,
  },
  confirmed: {
    label: 'Confirmed',
    color: Colors.textDefault,
  },
  worked: {
    label: 'Worked',
    color: Colors.midnightLighter,
  },
};
